import { StepData } from '@/lib/Steppers';
import { ISelectItem } from '@/models/select';

export enum CREATE_DATA_SOURCE_SFTP {
  NAME_AND_BUCKET,
  HEADER,
  DATA_TYPE,
  MAP_COLUMNS,
  INSTALLATION_SUCCESS,
}

export const CREATE_DATA_SOURCE_SFTP_STEPS: ReadonlyArray<StepData<number>> = [
  {
    id: CREATE_DATA_SOURCE_SFTP.NAME_AND_BUCKET,
    title: 'data_source_edit:sftp.steps.name_and_bucket',
  },
  {
    id: CREATE_DATA_SOURCE_SFTP.HEADER,
    title: 'data_source_edit:sftp.steps.header',
  },
  {
    id: CREATE_DATA_SOURCE_SFTP.DATA_TYPE,
    title: 'data_source_edit:sftp.steps.data_type',
  },
  {
    id: CREATE_DATA_SOURCE_SFTP.MAP_COLUMNS,
    title: 'data_source_edit:sftp.steps.map_columns',
  },
  {
    id: CREATE_DATA_SOURCE_SFTP.INSTALLATION_SUCCESS,
    title: 'data_source_edit:sftp.steps.confirmation',
  },
];

export const AUTH_METHODS = {
  password: 'password',
  privateKey: 'privateKey',
} as const;

export const AUTH_METHODS_OPTIONS: ISelectItem[] = Object.values(AUTH_METHODS).map((method) => ({
  id: method,
  label: method,
}));
